<template>
  <div :class="location">
    <div style="margin: 8px 0px;">
      <h4 class="tile-title">{{ title }}</h4>
      <span class="description" v-html="description"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TileOffer",
  props: {
    title: {
      type: String,
      required: true,
      default: () => "title"
    },
    description: {
      type: String,
      required: true,
      default: () => "description"
    },
    location: {
      type: String,
      required: true,
      default: () => ""
    }
  }
};
</script>
<style lang="scss" scoped>
.tile-title {
  margin-bottom: 3px;
}
</style>
